import React, { useState } from "react";
import {
  Heading,
  Text, // Text component is imported but not used, consider removing if not needed.
  Box,
  Button, // Button component is imported but not used, consider removing if not needed.
  HStack, // HStack component is imported but not used, consider removing if not needed.
  VStack,
  useTheme,
  Grid,
  GridItem,
} from "@chakra-ui/react";
import { ReactComponent as ThailandMap } from "../props/thmap.svg"; // นำเข้าไฟล์ SVG
import { useNavigate } from "react-router-dom"; // ใช้สำหรับ Navigate
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";

const regionData = {
  R1: {
    title: "พื้นที่ปศุสัตว์เขต 1",
    offices: [
      "สำนักงานปศุสัตว์จังหวัดพระนครศรีอยุธยา",
      "สำนักงานปศุสัตว์จังหวัดนนทบุรี",
      "สำนักงานปศุสัตว์จังหวัดชัยนาท",
      "สำนักงานปศุสัตว์จังหวัดอ่างทอง",
      "สำนักงานปศุสัตว์จังหวัดสิงห์บุรี",
      "สำนักงานปศุสัตว์จังหวัดสระบุรี",
      "สำนักงานปศุสัตว์จังหวัดลพบุรี",
      "สำนักงานปศุสัตว์จังหวัดปทุมธานี",
    ],
  },
  R2: {
    title: "พื้นที่ปศุสัตว์เขต 2",
    offices: [
      "สำนักงานปศุสัตว์จังหวัดนครนายก",
      "สำนักงานปศุสัตว์จังหวัดปราจีนบุรี",
      "สำนักงานปศุสัตว์จังหวัดตราด",
      "สำนักงานปศุสัตว์จังหวัดฉะเชิงเทรา",
      "สำนักงานปศุสัตว์จังหวัดจันทบุรี",
      "สำนักงานปศุสัตว์จังหวัดสมุทรปราการ",
      "สำนักงานปศุสัตว์จังหวัดสระแก้ว",
      "สำนักงานปศุสัตว์จังหวัดระยอง",
      "สำนักงานปศุสัตว์จังหวัดชลบุรี",
    ],
  },
  R3: {
    title: "พื้นที่ปศุสัตว์เขต 3",
    offices: [
      "สำนักงานปศุสัตว์จังหวัดชัยภูมิ",
      "สำนักงานปศุสัตว์จังหวัดนครราชสีมา",
      "สำนักงานปศุสัตว์จังหวัดบุรีรัมย์",
      "สำนักงานปศุสัตว์จังหวัดยโสธร",
      "สำนักงานปศุสัตว์จังหวัดศรีสะเกษ",
      "สำนักงานปศุสัตว์จังหวัดสุรินทร์",
      "สำนักงานปศุสัตว์จังหวัดอุบลราชธานี",
      "สำนักงานปศุสัตว์จังหวัดอำนาจเจริญ",
    ],
  },
  R4: {
    title: "พื้นที่ปศุสัตว์เขต 4",
    offices: [
      "สำนักงานปศุสัตว์จังหวัดอุดรธานี",
      "สำนักงานปศุสัตว์จังหวัดขอนแก่น",
      "สำนักงานปศุสัตว์จังหวัดหนองคาย",
      "สำนักงานปศุสัตว์จังหวัดกาฬสินธุ์",
      "สำนักงานปศุสัตว์จังหวัดเลย",
      "สำนักงานปศุสัตว์จังหวัดนครพนม",
      "สำนักงานปศุสัตว์จังหวัดมหาสารคาม",
      "สำนักงานปศุสัตว์จังหวัดหนองบัวลำภู",
      "สำนักงานปศุสัตว์จังหวัดสกลนคร",
      "สำนักงานปศุสัตว์จังหวัดมุกดาหาร",
      "สำนักงานปศุสัตว์จังหวัดบึงกาฬ",
      "สำนักงานปศุสัตว์จังหวัดร้อยเอ็ด",
    ],
  },
  R5: {
    title: "พื้นที่ปศุสัตว์เขต 5",
    offices: [
      "สำนักงานปศุสัตว์จังหวัดเชียงใหม่",
      "สำนักงานปศุสัตว์จังหวัดลำปาง",
      "สำนักงานปศุสัตว์จังหวัดลำพูน",
      "สำนักงานปศุสัตว์จังหวัดเชียงราย",
      "สำนักงานปศุสัตว์จังหวัดแม่ฮ่องสอน",
      "สำนักงานปศุสัตว์จังหวัดแพร่",
      "สำนักงานปศุสัตว์จังหวัดพะเยา",
      "สำนักงานปศุสัตว์จังหวัดน่าน",
    ],
  },
  R6: {
    title: "พื้นที่ปศุสัตว์เขต 6",
    offices: [
      "สำนักงานปศุสัตว์จังหวัดสุโขทัย",
      "สำนักงานปศุสัตว์จังหวัดกำแพงเพชร",
      "สำนักงานปศุสัตว์จังหวัดอุทัยธานี",
      "สำนักงานปศุสัตว์จังหวัดพิษณุโลก",
      "สำนักงานปศุสัตว์จังหวัดตาก",
      "สำนักงานปศุสัตว์จังหวัดอุตรดิตถ์",
      "สำนักงานปศุสัตว์จังหวัดนครสวรรค์",
      "สำนักงานปศุสัตว์จังหวัดพิจิตร",
      "สำนักงานปศุสัตว์จังหวัดเพชรบูรณ์",
    ],
  },
  R7: {
    title: "พื้นที่ปศุสัตว์เขต 7",
    offices: [
      "สำนักงานปศุสัตว์จังหวัดกาญจนบุรี",
      "สำนักงานปศุสัตว์จังหวัดเพชรบุรี",
      "สำนักงานปศุสัตว์จังหวัดนครปฐม",
      "สำนักงานปศุสัตว์จังหวัดราชบุรี",
      "สำนักงานปศุสัตว์จังหวัดสมุทรสาคร",
      "สำนักงานปศุสัตว์จังหวัดประจวบคีรีขันธ์",
      "สำนักงานปศุสัตว์จังหวัดสมุทรสงคราม",
      "สำนักงานปศุสัตว์จังหวัดสุพรรณบุรี",
    ],
  },
  R8: {
    title: "พื้นที่ปศุสัตว์เขต 8",
    offices: [
      "สำนักงานปศุสัตว์จังหวัดภูเก็ต",
      "สำนักงานปศุสัตว์จังหวัดกระบี่",
      "สำนักงานปศุสัตว์จังหวัดนครศรีธรรมราช",
      "สำนักงานปศุสัตว์จังหวัดระนอง",
      "สำนักงานปศุสัตว์จังหวัดพังงา",
      "สำนักงานปศุสัตว์จังหวัดชุมพร",
      "สำนักงานปศุสัตว์จังหวัดสุราษฎร์ธานี",
      "สำนักงานปศุสัตว์จังหวัดตรัง",
      "สำนักงานปศุสัตว์จังหวัดพัทลุง",
    ],
  },
  R9: {
    title: "พื้นที่ปศุสัตว์เขต 9",
    offices: [
      "สำนักงานปศุสัตว์จังหวัดปัตตานี",
      "สำนักงานปศุสัตว์จังหวัดสตูล",
      "สำนักงานปศุสัตว์จังหวัดสงขลา",
      "สำนักงานปศุสัตว์จังหวัดยะลา",
      "สำนักงานปศุสัตว์จังหวัดนราธิวาส",
    ],
  },
};

const MapInfoBox = () => {
  const theme = useTheme(); // Access the theme
  const navigate = useNavigate();
  
  const [hoveredRegion, setHoveredRegion] = useState(null);
  // const [hoveredRegionName, setHoveredRegionName] = useState(" "); // This state seems unused, consider removing.
  const [selectedRegion, setSelectedRegion] = useState("R1"); // ค่าเริ่มต้นเป็นเขต 1
  // const [clickedRegion, setClickedRegion] = useState("R1"); // This state is set but not used for display logic, selectedRegion is used. Consider if it's still needed.

  const handleMouseOver = (event) => {
    const regionName = event.target.closest("g")?.id || "Unknown";
    setHoveredRegion(regionName || null);
    // setHoveredRegionName(regionData[regionName]?.title || null); // Corresponds to unused hoveredRegionName state
  };

  const handleMouseOut = () => {
    setHoveredRegion(" "); // Or setHoveredRegion(null); for clarity
  };

  const handleClick = (event) => {
    const regionName = event.target.closest("g")?.id;
    if (regionName && regionData[regionName]) {
      setSelectedRegion(regionName);
      // setClickedRegion(regionName); // Corresponds to potentially unused clickedRegion state
    }
  };

  const handleOfficeClick = (office) => {
    navigate(`/mapofficelocation?office=${encodeURIComponent(office)}`);
  };

  // Define responsive font sizes using clamp if needed, similar to previous examples.
  // For now, using Chakra's theme-based sizes.
  const titleFontSize = "clamp(0.6rem, 1.8vw, 0.8rem)"; // Example: "2xl"
  const subtitleFontSize = "clamp(0.6rem, 1.8vw, 0.8rem)"; // Example: "md" or "lg"
  const officeListItemFontSize = "clamp(0.6rem, 1.8vw, 0.7rem)"; // Example: "xl"


  return (
    <Box textAlign="center" p={5} w="100%" bg="gray.600" borderRadius="2xl">
      <Grid templateColumns={{ base: "1fr", xl: "1fr 1fr" }} gap={6}> {/* Changed lg to auto for map column */}
        <GridItem>
          <Box textAlign="left" w="full">
            <Heading
              fontSize={titleFontSize} // Using responsive font size
              fontWeight="normal"
              mt={5}
              mb={2}
              color="white"
            >
              จุดจำหน่ายวัคซีนและวัคซีนคงคลัง
            </Heading>
            <Heading fontSize={officeListItemFontSize} fontWeight="normal" mb={2} color="white"> {/* Using responsive font size */}
              * คลิกในแผนที่เพื่อเลือกเขตปศุสัตว์ที่ต้องการ
            </Heading>
            <ThailandMap
              style={{
                width: "90%", // Takes 90% of its container
                minWidth: "250px", // **Added: Minimum width for the map**
                maxWidth: "600px", // **Optional: Maximum width for the map, if desired**
                height: "auto",
                cursor: "pointer",
                display: "block", // To help with centering or margin auto if needed
                margin: "0 auto" // Center map if its container is wider than 90% or maxWidth
              }}
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
              onClick={handleClick}
            />
            <style>
              {`
                #${selectedRegion} path {
                  fill: ${theme.colors.yellow[400]} !important; /* Highlight selected region */
                  transition: fill 0.2s ease-in-out;
                }
                ${hoveredRegion && hoveredRegion !== " " && hoveredRegion !== selectedRegion ?
                `
                #${hoveredRegion} path {
                  fill: ${theme.colors.whiteAlpha[800]} !important; /* Highlight hovered region if not selected */
                  transition: fill 0.2s ease-in-out;
                }
              ` : ''}
            `}
            </style>
          </Box>
          <Box textAlign="center" w="full" mt={5}>
            <Heading
              fontSize={officeListItemFontSize} // Using responsive font size
              fontWeight="normal"
              mb={2}
              color="white"
              cursor="pointer"
              _hover={{ color: theme.colors.yellow[300] }}
              onClick={() => handleOfficeClick("สำนักเทคโนโลยีชีวภัณฑ์สัตว์")}
            >
              <FontAwesomeIcon icon={faLocationDot} />  จุดจำหน่าย ณ สำนักเทคโนโลยีชีวภัณฑ์สัตว์
            </Heading>
          </Box>
        </GridItem>
        {/* ส่วนแสดงข้อมูล */}
        <GridItem>
          <Box
            textAlign="left"
            p={5}
            // m={5} // Margin can be adjusted or removed depending on layout with Grid gap
            bg="gray.200"
            borderRadius="2xl"
            h="100%" // Make it take full height of the grid row
            minH="450px" // Ensure the info box has a minimum height
            overflowY="auto" // Add scroll if content overflows
          >
            {selectedRegion && regionData[selectedRegion] ? (
              <>
                <Heading fontSize={titleFontSize} mb={3} color="gray.600" mt={5}> {/* Using responsive font size */}
                  {regionData[selectedRegion].title}
                </Heading>
                <VStack align="start" spacing={3} mt={5}> {/* Reduced spacing slightly */}
                  {regionData[selectedRegion].offices.map((office, index) => (
                    <Heading
                      key={index}
                      fontSize={officeListItemFontSize} // Using responsive font size
                      fontWeight="normal"
                      color="gray.700"
                      cursor="pointer"
                      _hover={{ color: "blue.500" }}
                      onClick={() => handleOfficeClick(office)}
                    >
                      - {office}
                    </Heading>
                  ))}
                </VStack>
              </>
            ) : (
              <Text color="gray.700" mt={5}>กรุณาเลือกเขตในแผนที่</Text>
            )}
          </Box>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default MapInfoBox;